import Vue from 'vue'
import Router from 'vue-router'
import shanxinApp from './modules/shanxin-app'

import attractTraffic from './modules/attract-traffic'
import version2 from './modules/version2'
import version3 from './modules/version3'
import h5version from './modules/h5version'
import kuaishou from './modules/kuaishou'
import airoute from './modules/ai'
import other from './modules/other'
Vue.use(Router)
const router = new Router({
  routes: [
    ...shanxinApp,...attractTraffic,...version2,...version3,...airoute,
    ...kuaishou,...other,...h5version,
    {
      path: '/',
      component: () => import('@/pages/attractTraffic/download1.vue'),
      meta: {
        title: '智借',
        keepAlive: true
      }
    }, {
      path: '/credit',
      name: 'CreditInfo',
      component: () => import('@/pages/credit/info/index.vue'),
      meta: {
        title: '基本信息',
        keepAlive: true
      }
    }, {
      path: '/credit/result/:status?',
      name: 'CreditResult',
      component: () => import('@/pages/credit/result/index.vue'),
      meta: {
        title: '担保额度评估结果',
        keepAlive: true
      }
    }, {
      path: '/loan',
      name: 'LoanInfo',
      component: () => import('@/pages/loan/info/index.vue'),
      meta: {
        title: '提现',
        keepAlive: true
      }
    },{
      path: '/third-loan',
      name: 'ThirdLoan',
      component: () => import('@/pages/loan/info/third-loan.vue'),
      meta: {
        title: '我要提现',
        keepAlive: false
      }
    }, {
      path: '/loan/bind',
      name: 'LoanBindCard',
      component: () => import('@/pages/loan/bind/index.vue'),
      meta: {
        title: '绑定银行卡',
        keepAlive: false
      }
    }, {
      path: '/loan/result/:status',
      name: 'LoanResult',
      component: () => import('@/pages/loan/result/index.vue'),
      meta: {
        title: '提现结果',
        keepAlive: true
      }
    },
    {
      path: '/third-loan-result/:status',
      component: () => import('@/pages/loan/result/third-loan-result'),
      meta: {
        title: '提现结果',
      }
    },
    {
      path: '/navbill',
      component: () => import('@/pages/repay/order/navbill.vue'),
      meta: {
        title: '账单',
        keepAlive: true
      }
    },
    {
      path: '/repay',
      component: () => import('@/pages/repay/order/navbill.vue'),
      meta: {
        title: '还款列表',
        keepAlive: true
      }
    }, {
      path: '/repay/detail',
      name: 'RepayOrderDetail',
      component: () => import('@/pages/repay/order/detail.vue'),
      meta: {
        title: '账单详情',
        keepAlive: true
      }
    }, {
      path: '/repay/result/:status',
      name: 'RepayResult',
      component: () => import('@/pages/repay/result/index.vue'),
      meta: {
        title: '还款结果',
        keepAlive: true
      }
    },

     {
      path: '/myloan/list',
      name: 'myLoanList',
      component: () => import('@/pages/myLoan/list/index.vue'),
      meta: {
        title: '我的借款-列表',
        keepAlive: true
      }
    }, {
      path: '/myloan/detail/:status',
      name: 'myLoanDetail',
      component: () => import('@/pages/myLoan/detail/index.vue'),
      meta: {
        title: '我的借款-详情',
        keepAlive: true
      }
    }, {
      path: '/offline-product-apply-success',
      name: 'offlineProductAapplySuccess',
      component: () => import('@/pages/credit/result/offline-product-apply-success.vue'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/real-name-auth',
      component: () => import('@/pages/credit/info/real-name-auth.vue'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/form-info',
      component: () => import('@/pages/credit/info/form-info.vue'),
      meta: {
        title: '个人信息',
        keepAlive: true
      }
    },
    {
      path: '/add-info',
      component: () => import('@/pages/credit/info/add-info.vue'),
      meta: {
        title: '联系人信息',
        keepAlive: true
      }
    },

    {
      path: '/p3match',
      component: () => import('@/pages/credit/info/p3match.vue'),
      meta: {
        title: '个人信息-协议',
        keepAlive: true
      }
    },
    {
      path: '/p3-match-popup',
      component: () => import('@/pages/credit/info/p3-match-popup.vue'),
      meta: {
        title: '产品推荐',
        keepAlive: true
      }
    },
    {
      path: '/vipright',
      component: () => import('@/pages/vip/vipright.vue'),
      meta: {
        title: '智能方案借款',
        keepAlive: true
      }
    },
    {
      path: '/right-introduce',
      component: () => import('@/pages/vip/right-introduce.vue'),
      meta: {
        title: '智能借款方案',
        keepAlive: true
      }
    },
    {
      path: '/amount-assess',
      component: () => import('@/pages/vip/amount-assess.vue'),
      meta: {
        title: '担保额度评估中',
        keepAlive: true
      }
    },




    //对外机构协议页
    {
      path: '/organization-agreement',
      component: () => import('@/pages/other/agreement/organization-agreement.vue'),
      meta: {
        title: '机构协议',
        keepAlive: true
      }
    },
    //-----------404--------------------
    {
      path: '/404err',
      component: () => import('@/pages/Empty/404err.vue'),
      meta: {
        title: '页面不见了',
        keepAlive: false
      }
    },

    //-----------审核结果页--------------------
    {
      path: '/jieguoye',
      component: () => import('@/pages/credit/result/jieguoye.vue'),
      meta: {
        title: '审核中',
        keepAlive: true
      }
    },
    //-------------审核表单页----------------------------------------
    {
      path: '/shenheform',
      component: () => import('@/pages/review/form-info.vue'),
      meta: {
        title: '个人信息',
        keepAlive: true
      }
    },

    //测试页
    {
      path: '/testpage/premissionlist',
      component: () => import('@/pages/testpage/premissionlist.vue'),
      meta: {
        title: '测试',
        keepAlive: false
      }
    },
  ]
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js